import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useThemeStore } from "src/stores/themeStore";

const ReactToastifyRoot = () => {
  const theme = useThemeStore((s) => s.theme);
  return (
    <ToastContainer
      position="top-center"
      autoClose={5000}
      closeOnClick={false}
      draggable={false}
      pauseOnFocusLoss
      pauseOnHover
      theme={theme === "dark" ? "dark" : "colored"}
    />
  );
};

export default ReactToastifyRoot;
